import React from "react";
import { Drawer, IconButton, Typography } from "@material-ui/core";
import { MdClose } from "react-icons/md";
import styled from "styled-components";
import { IAttributes } from "../../reducers/project";
import { mapCategoryToAttribute } from "./AttributesDrawer";
import content from "../../content";
import question from '../../assets/icons/question.png'
import {imgRelative, mapsimg} from "./AttributesExpansion";

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f5f4f4;
  font-size: 16px;
  border: 1px solid #eae5e5;
  box-sizing: border-box;
  height: 40px;
  min-height: 40px;
  padding: 0px 16px;
`;

const Content = styled.div`
  border: 1px solid #eae5e5;
  height: 100%;
  padding: 24px;
`;

const Name = styled.div`
  width: 100%;
  color: #080808;
  font-size: 22px;
  margin: 25px 0px;
`;

const Price = styled.div`
  color: #c41230;
  font-size: 14px;
  margin-bottom: 25px;
`;

const Desc = styled.div`
  color: #666666;
  opacity: 0.6;
  font-size: 12px;
  line-height: 22px;
  margin-bottom: 25px;
`;

export const Close = styled.div`
  font-size: 12px;
  text-decoration-line: underline;
  color: #c41230;
  cursor: pointer;
`;

function AttrubuteInfo({ attribute, open, onClose }: IAttrubuteInfo) {
  return (
    <Drawer
      variant={"persistent"}
      anchor={"right"}
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          position: "absolute",
          width: "100%",
          padding: "24px",
          border: "1px solid #EAE5E5",
          boxSizing: "border-box",
        },
      }}
      BackdropProps={{ style: { position: "absolute" } }}
    >
      <Header>
        {attribute?.category && (
          <div>{mapCategoryToAttribute(attribute?.category)}</div>
        )}
      </Header>
      <Content>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          {process?.env?.REACT_APP_URL && (
            <img
              height={"150px"}
              width={"auto"}
              src={imgRelative(mapsimg(attribute))}
            />
          )}
          <IconButton
            style={{ position: "absolute", right: "48px" }}
            onClick={onClose}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#EBEBEB" />
              <line
                x1="8.46443"
                y1="8.46446"
                x2="15.5355"
                y2="15.5355"
                stroke="#919090"
                stroke-width="2"
              />
              <line
                x1="15.5357"
                y1="8.46446"
                x2="8.46465"
                y2="15.5355"
                stroke="#919090"
                stroke-width="2"
              />
            </svg>
          </IconButton>
        </div>
        <Name>{attribute?.name}</Name>
        <Price>
          {attribute?.price} {content.getValue("currency")}
        </Price>
        <Desc>{attribute?.description}</Desc>
        <Close onClick={onClose}>{content.getValue("close")}</Close>
      </Content>
    </Drawer>
  );
}

export interface IAttrubuteInfo {
  open: boolean;
  attribute: IAttributes | null;
  onClose: () => void;
}

export default AttrubuteInfo;
